import React from 'react';
export const ProductSection = () => {
  return <section className="py-4" data-id="element-79">
      <div className="mb-6" data-id="element-80">
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-81">
          While chatting over the fence one morning, Margaret mentioned to her
          neighbour, Joan, who also had cats, that she was struggling with
          severe chest pain and breathing issues because of cat dander. She
          asked Joan, "How do you manage to have visitors over with your two
          cats without everyone being overwhelmed by allergens?"
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-82">
          Joan smiled and said, "Wait right there, I'll duck inside and grab
          something."
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-83">
          A few minutes later, Joan returned, grinning from ear to ear, holding
          a small white device no bigger than her hand.
        </p>
        <a href="https://petssey.com/products/petssey-dnrx" data-id="element-84">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/24BLfJUuF6bHi4LzEUQYxv/img_2.webp" alt="Young woman giving a blue box with question mark to an elderly woman" className="w-full md:w-1/2 h-auto object-cover rounded mb-4 md:mb-0 md:mr-4" data-id="element-85" />
        </a>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-86">
          "Trust me," said Joan. "You'll love this little cat dander-eliminating
          device; it's the perfect solution and was specifically designed for us
          cat parents. I use one in my bedroom and lounge room, but you can
          place them anywhere you don't want pesky cat dander and airborne
          allergens lingering. It works like magic!"
        </p>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-87">
          "She wasn't fibbing," said Margaret.
        </p>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-88">
          "That very evening, I plugged it in and let it run. I was sceptical at
          first, but to my amazement, the air felt crisp and fresh, and there
          wasn't a trace of lingering cat dander. Not a single sneeze or sniffle
          after that!"
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-89">
          Margaret didn't realise how contaminated her air had become until her
          chest pain vanished and her breathing returned to normal! She no
          longer felt anxious or suffered from relentless cat allergies and
          sinus congestion. She felt lighter on her feet and ready to reclaim
          her life as if she'd been given a second chance!
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-90">
          The compact device had a label that read: '
          <a href="https://petssey.com/products/petssey-dnrx" className="text-blue-600 hover:underline" data-id="element-91">
            Petssey DNRx
          </a>
          '.
        </p>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-92">
          "I had no idea how it worked at the time, but I was thrilled,"
          Margaret recalls. "I immediately jumped online and ordered several
          more, just to ensure I had one in every room of my house."
        </p>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-93">
          "The best part is," said Margaret. "This air purifier is
          whisper-quiet, incredibly simple to use, and highly energy-efficient.
          Plus it works automatically around the clock so Mittens and I never
          have to do anything to breathe fresher air. I ordered 6 more after I
          noticed they'd sold out twice before!"
        </p>
      </div>
      <div className="mb-6" data-id="element-94">
        <p className="text-[24px] font-bold text-[#323232] mb-4 leading-[1.1]" data-id="element-95">
          It's called Petssey DNRx, and the way it eliminates lingering cat
          dander and allergens is surprisingly simple yet remarkably effective.
        </p>
        <img src="https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExOGh3ZjYxejAydXlwbzl5bHhiMXprYm92M3VpOWpnZDNjY3UwODl5ayZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/pevP50rkWznNoGLMCW/giphy.gif" alt="An animated kitten sheds fur and floats up near the device - animated GIF" className="w-full md:w-1/2 h-auto object-cover rounded mb-4 md:mb-0 md:mr-4" data-id="element-96" />
        <div className="flex flex-col md:flex-row items-center mb-6" data-id="element-97">
          <div className="md:w-1/2" data-id="element-98">
            <p className="text-[22px] text-[#323232] mb-4" data-id="element-99">
              Unlike the bulky purifiers she'd wasted money on,{' '}
              <a href="https://petssey.com/products/petssey-dnrx" className="text-blue-600 hover:underline" data-id="element-100">
                Petssey DNRx
              </a>
              , worked in a completely different way. Instead of trying to trap
              allergens with noisy fans and endless filters, it released{' '}
              <strong data-id="element-101">safe negative ions</strong> into the air — the same{' '}
              <strong data-id="element-102">natural particles</strong> you find after a thunderstorm
              or near a waterfall.
            </p>
            <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-103">
              "These ions <strong data-id="element-104">act</strong> like tiny{' '}
              <strong data-id="element-105">magnets</strong>," Margaret explained. "They{' '}
              <strong data-id="element-106">grab</strong>
              onto the <strong data-id="element-107">invisible</strong> cat dander floating around my
              house, <strong data-id="element-108">clump</strong> it together, and{' '}
              <strong data-id="element-109">pull it out of the air</strong>. Instead of me breathing
              it in, it just <strong data-id="element-110">falls harmlessly away</strong>."
            </p>
          </div>
        </div>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-111">
          For Margaret, the difference was immediate. "I couldn't believe
          something so small and quiet could do what my giant purifier never
          could. I woke up with clear sinuses and could finally sit with Mr.
          Mittens on my lap without wheezing."
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-112">
          And unlike the old ionisers she remembered hearing about years ago,
          Petssey DNRx was <strong data-id="element-113">fully ozone-safe</strong> and tested for
          continuous use. She could{' '}
          <strong data-id="element-114">keep it running day and night</strong> — even around her
          grandkids — without a worry.
        </p>
        <img src="https://media.giphy.com/media/wmnJ3YvrU0EWty4fSj/giphy.gif" alt="Gif of PetsseyDNRx in use against allergen filled air" className="w-full h-auto object-cover rounded mb-4" data-id="element-115" />
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-116">
          It's no surprise then that the DNRx, which also uses negative ion
          technology to eliminate cat dander, is so powerful and successful.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-117">
          The Petssey DNRx is truly the easiest and quickest way to protect your
          rooms from persistent cat allergens. It effectively neutralises all
          types of airborne particles and purifies the air you and your family
          breathe!
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-118">
          Margaret didn't realise how poor her air quality had become until she
          plugged in her DNRx and immediately noticed the difference...
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-119">
          DNRx automatically eliminates cat dander allergens 24/7 so Margaret
          and Mittens can breathe fresher, cleaner air without lifting a finger!
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-120">
          No more worrying about giving up her cat and no more expensive air
          purifiers and professional cleaners that don't target the root cause
          of her cat allergies.
        </p>
        <a href="https://petssey.com/products/petssey-dnrx" data-id="element-121">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pLcZoMU7d3b1AmnBdL1KMm/ChatGPT_Image_Sep_9%2C_2025%2C_02_21_52_PM.png" alt="Group of seniors enjoying tea together with a tabby cat on the couch in a bright living room" className="w-full h-auto object-cover rounded mb-4" data-id="element-122" />
        </a>
      </div>
    </section>;
};